import './Messagerie.css';

/**
 * Un groupe du formulaire d'écriture d'un courriel : le destinataire, puis le
 * courriel lui-même. Des cartes numérotées se lisent comme des étapes, dans
 * l'ordre où on les remplit, plutôt qu'une seule colonne de champs.
 *
 * `teinte` donne le liseré de la carte : on reconnaît le groupe avant d'en lire
 * le titre.
 */
export default function SectionMail({ numero, titre, aide, teinte, children }) {
  return (
    <section className={`section-mail${teinte ? ` section-mail--${teinte}` : ''}`}>
      <header className="section-mail__entete">
        {numero && <span className="section-mail__numero" aria-hidden="true">{numero}</span>}

        <div>
          <h3 className="section-mail__titre">{titre}</h3>
          {aide && <p className="section-mail__aide">{aide}</p>}
        </div>
      </header>

      <div className="section-mail__corps">{children}</div>
    </section>
  );
}
